// Form validation translations
const dictFormValidation = {
    // Required field messages
    required_field: {
        th: "กรุณากรอกข้อมูลในช่องที่จำเป็น",
        en: "Please fill in all required fields",
        ja: "必須項目を入力してください",
    },
    required_field_name: {
        th: "กรุณากรอก{fieldName}",
        en: "Please fill in {fieldName}",
        ja: "{fieldName}を入力してください",
    },

    // Email validation
    invalid_email: {
        th: "กรุณากรอกอีเมลที่ถูกต้อง",
        en: "Please enter a valid email address",
        ja: "有効なメールアドレスを入力してください",
    },

    // URL validation
    invalid_url: {
        th: "กรุณากรอก URL ที่ถูกต้อง",
        en: "Please enter a valid URL",
        ja: "有効なURLを入力してください",
    },

    // Length validation
    min_length: {
        th: "ข้อมูลต้องมีความยาวอย่างน้อย {min} ตัวอักษร",
        en: "Text must be at least {min} characters long",
        ja: "テキストは{min}文字以上である必要があります",
    },
    min_length_field: {
        th: "{fieldName}ต้องมีความยาวอย่างน้อย {min} ตัวอักษร",
        en: "{fieldName} must be at least {min} characters long",
        ja: "{fieldName}は{min}文字以上である必要があります",
    },
    max_length: {
        th: "ข้อมูลต้องมีความยาวไม่เกิน {max} ตัวอักษร",
        en: "Text must be no longer than {max} characters",
        ja: "テキストは{max}文字以下である必要があります",
    },
    max_length_field: {
        th: "{fieldName}ต้องมีความยาวไม่เกิน {max} ตัวอักษร",
        en: "{fieldName} must be no longer than {max} characters",
        ja: "{fieldName}は{max}文字以下である必要があります",
    },

    // Number validation
    invalid_number: {
        th: "กรุณากรอกตัวเลขที่ถูกต้อง",
        en: "Please enter a valid number",
        ja: "有効な数字を入力してください",
    },
    invalid_number_field: {
        th: "กรุณากรอก{fieldName}เป็นตัวเลขที่ถูกต้อง",
        en: "Please enter a valid number for {fieldName}",
        ja: "{fieldName}に有効な数字を入力してください",
    },
    min_value: {
        th: "ค่าต้องไม่น้อยกว่า {min}",
        en: "Value must not be less than {min}",
        ja: "値は{min}以上である必要があります",
    },
    max_value: {
        th: "ค่าต้องไม่เกิน {max}",
        en: "Value must not exceed {max}",
        ja: "値は{max}以下である必要があります",
    },

    // Pattern validation
    invalid_format: {
        th: "รูปแบบข้อมูลไม่ถูกต้อง",
        en: "Invalid format",
        ja: "フォーマットが正しくありません",
    },
    invalid_format_field: {
        th: "รูปแบบข้อมูลของ{fieldName}ไม่ถูกต้อง",
        en: "{fieldName} has an invalid format",
        ja: "{fieldName}の形式が正しくありません",
    },
    invalid_phone: {
        th: "กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง",
        en: "Please enter a valid phone number",
        ja: "有効な電話番号を入力してください",
    },

    // File validation
    file_too_large: {
        th: "ไฟล์มีขนาดใหญ่เกินไป (สูงสุด {maxSize})",
        en: "File is too large (maximum {maxSize})",
        ja: "ファイルサイズが大きすぎます（最大{maxSize}）",
    },
    invalid_file_type: {
        th: "ประเภทไฟล์ไม่ถูกต้อง",
        en: "Invalid file type",
        ja: "ファイル形式が正しくありません",
    },

    // Confirmation validation
    passwords_not_match: {
        th: "รหัสผ่านไม่ตรงกัน",
        en: "Passwords do not match",
        ja: "パスワードが一致しません",
    },

    // General validation
    please_check_form: {
        th: "กรุณาตรวจสอบข้อมูลในฟอร์ม",
        en: "Please check the form data",
        ja: "フォームの内容を確認してください",
    },
    validation_failed: {
        th: "การตรวจสอบข้อมูลล้มเหลว",
        en: "Validation failed",
        ja: "検証に失敗しました",
    },

    // Field names for better error messages
    field_names: {
        username: {
            th: "ชื่อผู้ใช้",
            en: "Username",
            ja: "ユーザー名",
        },
        email: {
            th: "อีเมล",
            en: "Email",
            ja: "メールアドレス",
        },
        password: {
            th: "รหัสผ่าน",
            en: "Password",
            ja: "パスワード",
        },
        password_confirmation: {
            th: "ยืนยันรหัสผ่าน",
            en: "Confirm Password",
            ja: "パスワード確認",
        },
        title: {
            th: "หัวข้อ",
            en: "Title",
            ja: "タイトル",
        },
        content: {
            th: "เนื้อหา",
            en: "Content",
            ja: "内容",
        },
        name: {
            th: "ชื่อ",
            en: "Name",
            ja: "名前",
        },
        first_name: {
            th: "ชื่อจริง",
            en: "First Name",
            ja: "名",
        },
        last_name: {
            th: "นามสกุล",
            en: "Last Name",
            ja: "姓",
        },
        nickname: {
            th: "ชื่อเล่น",
            en: "Nickname",
            ja: "ニックネーム",
        },
        phone: {
            th: "หมายเลขโทรศัพท์",
            en: "Phone Number",
            ja: "電話番号",
        },
        address: {
            th: "ที่อยู่",
            en: "Address",
            ja: "住所",
        },
        website: {
            th: "เว็บไซต์",
            en: "Website",
            ja: "ウェブサイト",
        },
        description: {
            th: "คำอธิบาย",
            en: "Description",
            ja: "説明",
        },
        message: {
            th: "ข้อความ",
            en: "Message",
            ja: "メッセージ",
        },
    },
};

export { dictFormValidation };
